import * as React from "react";
import { FileItem, PageProps } from './components/component-switcher';

export interface AppColors {
    textColors: ColorSet;
    defaultColors: ColorSet;
    buttonColors: ColorSet;
}

export interface ColorSet {
    primaryColor: string;
    secondaryColor: string;
    accentColor: string;
}

export interface AppContextInterface {
    id: number;
    mainLogo?: FileItem;
    title?: string;
    pageTree: PageTree | null;
    styles: AppStyles | null;
    children?: any[];
    pageData?: any;
    currentSection?: string;

}


export interface PageTree extends PageProps {
    mainLogo: string;
}

export interface StyleSet {
    light: string;
    dark: string;
    muted: string;
    vibrant: string;
}

export interface AppStyles {
    heading: StyleSet;
    bodyText: StyleSet;
    default: StyleSet;
    buttonColors: StyleSet;
    background: StyleSet;
}

const ctxt = React.createContext<AppContextInterface | null>(null);

export const AppContext = ctxt;

